import { Stack } from '@mui/material'
import type { FC } from 'react'

type Props = {
  width?: number
}

const FormStack: FC<Props> = ({ width, children }) => (
  <Stack width={width} spacing={2}>
    {children}
  </Stack>
)

export default FormStack
